import { render, staticRenderFns } from "./PurchaseRequestDetail.vue?vue&type=template&id=7970d2e5&scoped=true"
import script from "./PurchaseRequestDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseRequestDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseRequestDetail.vue?vue&type=style&index=0&id=7970d2e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7970d2e5",
  null
  
)

export default component.exports